import { Typography, Box, IconButton, Tooltip } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

interface TitleProps {
  title: string;
  subtitle: string;
  onBack?: () => void;
}
const Title: React.FC<TitleProps> = (props) => {
  return (
    <Box mb={3} display="flex" alignItems="center" gap={1.5}>
      {props.onBack && (
        <Tooltip title="Back">
          <IconButton
            onClick={props.onBack}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              color: "text.primary",
              "&:hover": { bgcolor: "primary.light", color: "primary.main" },
            }}
          >
            <ArrowBackRoundedIcon />
          </IconButton>
        </Tooltip>
      )}
      <Box>
        <Typography variant="h5" color="text.primary" sx={{ lineHeight: 1.25 }}>
          {props.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          {props.subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default Title;
